import React, { memo } from 'react'
import { Chip, Grid, Typography } from '@mui/material'
import {
    SurfaceSubtitleContent,
    SurfaceSubtitleProps,
} from './SurfaceSubtitle.types'

function SurfaceSubtitle({ subtitle }: SurfaceSubtitleProps) {
    const textVariant = (text: string) => (
        <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
                {text}
            </Typography>
        </Grid>
    )

    const gridVariant = ({
        text,
        complement,
        labels,
    }: SurfaceSubtitleContent) => (
        <Grid item xs={12}>
            <Grid
                container
                justifyContent="flex-start"
                alignContent="center"
                alignItems="center"
                spacing={1}
            >
                {text && (
                    <Grid item xs="auto">
                        {textVariant(text)}
                    </Grid>
                )}
                {complement && (
                    <Grid item xs="auto">
                        {complement}
                    </Grid>
                )}
                {labels?.map((label, i) => (
                    <Grid key={`${label.text}-${i}`} item xs="auto">
                        <Chip
                            label={label.text}
                            size="small"
                            variant={label.variant ?? 'outlined'}
                            color={label.color ?? 'info'}
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )

    if (typeof subtitle === 'string') {
        return textVariant(subtitle)
    }

    return gridVariant(subtitle)
}

export default memo(SurfaceSubtitle)
